import { AbstractMesh, type Node } from '@babylonjs/core';

/** Every mesh in a model: its root, when that is a mesh itself, and all the meshes under it. */
export function listMeshesUnder(root: Node): AbstractMesh[] {
    const children = root.getChildMeshes(false);
    return root instanceof AbstractMesh ? [root, ...children] : children;
}
